import React from 'react';
import { fmtMoney, fmtPct, fmtPp, directionClass } from '../utils/format';

const Row = ({ label, a, b, deltaAmount, deltaPercent, deltaPp, upIsGood = true, isTotal = false, isKey = false }) => {
    const dirCls = directionClass(deltaAmount ?? 0, { upIsGood });
    return (
        <tr className={`${isTotal ? 'fr-cmp-total' : ''} ${isKey ? 'fr-cmp-key' : ''}`}>
            <td>{label}</td>
            <td className="fr-num">{fmtMoney(a?.amount)}</td>
            <td className="fr-num fr-pct-cell">{fmtPct(a?.percent)}</td>
            <td className="fr-num">{fmtMoney(b?.amount)}</td>
            <td className="fr-num fr-pct-cell">{fmtPct(b?.percent)}</td>
            <td className={`fr-num ${dirCls}`}>{deltaAmount === 0 ? '—' : (deltaAmount > 0 ? '+' : '') + fmtMoney(deltaAmount, { currency: '' })}</td>
            <td className={`fr-num ${dirCls}`}>{fmtPct(deltaPercent, 1)}</td>
            <td className={`fr-num ${directionClass(deltaPp ?? 0, { upIsGood })}`}>{fmtPp(deltaPp)}</td>
        </tr>
    );
};

const ItemRows = ({ items, upIsGood }) => (
    <>
        {items.map((row, idx) => (
            <Row
                key={idx}
                label={row.name}
                a={row.a}
                b={row.b}
                deltaAmount={row.deltaAmount}
                deltaPercent={row.deltaPercent}
                deltaPp={row.deltaPp}
                upIsGood={upIsGood}
            />
        ))}
    </>
);

const PnLComparisonTable = ({ comparison }) => {
    if (!comparison) return null;
    const { totals, lineItems, periodA, periodB } = comparison;

    return (
        <div className="fr-cmp-wrap">
            <div className="fr-card-header">
                <h3>P&L Comparison · {periodA.label} vs {periodB.label}</h3>
                <p>Side-by-side line items with deltas in amount, percentage and percentage-points of sales.</p>
            </div>
            <div className="fr-cmp-table-wrap">
                <table className="fr-cmp-table">
                    <thead>
                        <tr>
                            <th rowSpan={2}>Item</th>
                            <th colSpan={2}>{periodA.label}</th>
                            <th colSpan={2}>{periodB.label}</th>
                            <th rowSpan={2}>Δ Amount</th>
                            <th rowSpan={2}>Δ %</th>
                            <th rowSpan={2}>Δ pp</th>
                        </tr>
                        <tr>
                            <th className="fr-num">Amount</th>
                            <th className="fr-num">% Sales</th>
                            <th className="fr-num">Amount</th>
                            <th className="fr-num">% Sales</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="fr-cmp-section"><td colSpan={8}>Direct Income</td></tr>
                        <ItemRows items={lineItems.directIncome} upIsGood />
                        <Row label="Total Direct Income" a={totals.sales.a} b={totals.sales.b}
                             deltaAmount={totals.sales.deltaAmount} deltaPercent={totals.sales.deltaPercent}
                             deltaPp={totals.sales.deltaPp} upIsGood isTotal />

                        <tr className="fr-cmp-section"><td colSpan={8}>Direct Expenses</td></tr>
                        <ItemRows items={lineItems.directExpenses} upIsGood={false} />
                        <Row label="Total Direct Expenses" a={totals.directExpenses.a} b={totals.directExpenses.b}
                             deltaAmount={totals.directExpenses.deltaAmount} deltaPercent={totals.directExpenses.deltaPercent}
                             deltaPp={totals.directExpenses.deltaPp} upIsGood={false} isTotal />

                        <Row label="GROSS PROFIT / LOSS" a={totals.grossProfit.a} b={totals.grossProfit.b}
                             deltaAmount={totals.grossProfit.deltaAmount} deltaPercent={totals.grossProfit.deltaPercent}
                             deltaPp={totals.grossProfit.deltaPp} upIsGood isKey />

                        <tr className="fr-cmp-section"><td colSpan={8}>Indirect Expenses</td></tr>
                        <ItemRows items={lineItems.indirectExpenses} upIsGood={false} />
                        <Row label="Total Indirect Expenses" a={totals.indirectExpenses.a} b={totals.indirectExpenses.b}
                             deltaAmount={totals.indirectExpenses.deltaAmount} deltaPercent={totals.indirectExpenses.deltaPercent}
                             deltaPp={totals.indirectExpenses.deltaPp} upIsGood={false} isTotal />

                        <Row label="Total Expense" a={totals.totalExpense.a} b={totals.totalExpense.b}
                             deltaAmount={totals.totalExpense.deltaAmount} deltaPercent={totals.totalExpense.deltaPercent}
                             deltaPp={totals.totalExpense.deltaPp} upIsGood={false} isTotal />

                        <Row label="NET OPERATING PROFIT / LOSS" a={totals.netOperating.a} b={totals.netOperating.b}
                             deltaAmount={totals.netOperating.deltaAmount} deltaPercent={totals.netOperating.deltaPercent}
                             deltaPp={totals.netOperating.deltaPp} upIsGood isKey />

                        <tr className="fr-cmp-section"><td colSpan={8}>Indirect Income</td></tr>
                        <ItemRows items={lineItems.indirectIncome} upIsGood />
                        <Row label="Total Indirect Income" a={totals.indirectIncome.a} b={totals.indirectIncome.b}
                             deltaAmount={totals.indirectIncome.deltaAmount} deltaPercent={totals.indirectIncome.deltaPercent}
                             deltaPp={totals.indirectIncome.deltaPp} upIsGood isTotal />

                        <Row label="NET PROFIT / LOSS" a={totals.netProfit.a} b={totals.netProfit.b}
                             deltaAmount={totals.netProfit.deltaAmount} deltaPercent={totals.netProfit.deltaPercent}
                             deltaPp={totals.netProfit.deltaPp} upIsGood isKey />
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PnLComparisonTable;
